import React from 'react';
import {View, StyleSheet, Modal as ModalReact, TouchableOpacity, SafeAreaView, Text} from 'react-native';
import {Sizes, TextStyles, Colors, CloseIcon} from '../index';
import {ComponentProps} from './ComponentProps';

interface ModalProps extends ComponentProps {
  title?: string;
  isVisible: boolean;
  setIsVisible(visible: boolean): void;
}

export const Modal = (props: React.PropsWithChildren<ModalProps>) => {
  const titleStyle = [styles.title, TextStyles.textMediumL];
  return (
    <ModalReact
      animationType="slide"
      // transparent={true}
      presentationStyle="formSheet"
      visible={props.isVisible}
      onRequestClose={() => {
        props.setIsVisible(!props.isVisible);
      }}>
      <SafeAreaView style={styles.container}>
        <View style={styles.topContainer}>
          <Text style={titleStyle}>{props.title}</Text>
          <TouchableOpacity
            onPress={() => props.setIsVisible(false)}
            style={styles.closeButton}
            testID={'ModalcloseButton'}>
            <CloseIcon />
          </TouchableOpacity>
        </View>
        <View style={styles.childContainer}>{props.children}</View>
      </SafeAreaView>
    </ModalReact>
  );
};

const styles = StyleSheet.create({
  container: {flex: 1, backgroundColor: Colors.background},
  topContainer: {
    paddingTop: Sizes.m,
    paddingRight: 3,
    paddingLeft: Sizes.m,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    color: Colors.primary,
  },
  closeButton: {
    width: 44,
    height: 44,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  childContainer: {
    flex: 1,
    padding: Sizes.m,
  },
});
